import { render, staticRenderFns } from "./WaffleRun.vue?vue&type=template&id=4332e144&"
import script from "./WaffleRun.vue?vue&type=script&lang=js&"
export * from "./WaffleRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports